import React from "react";
import HoaOffer from "../HoaOffer/HoaOffer";
import HoaPlan from "../HoaPlan/HoaPlan";
import HoaTestimonial from "../HoaTestimonial/HoaTestimonial";
import HoaContact from "../HoaContact/HoaContact";


import HoaHome from "../HoaHome/HoaHome";
import HoaScroll from "../HoaScroll/HoaScroll";
import HoaFooter from "../HoaFooter/HoaFooter";
import FAQ from "../HoaFAQ/HoaFAQ";
import Features from "../Hoafeatures/Hoafeatures";
import FeatureSections from "../Hoafeaturesection/Hoafeaturesection";
import ValueProposition from "../HoaValuePropotion/HoaValuePropotion";
import AboutUs from "../AboutUS/AboutUs";

const HoaComponent = () => {
  return (
    <div>
      <HoaHome />
      <ValueProposition/>
      {/* <AboutUss/> */}
      {/*<HoaOffer />*/}
      <Features/>
      <HoaPlan />
      <FeatureSections/>
      <FAQ />
      {/*<HoaTestimonial />*/}
      <HoaContact />
      <HoaFooter />
      <HoaScroll />
    </div>
  );
};

export default HoaComponent;
